// extracted by mini-css-extract-plugin
module.exports = {"image":"WidePictureNoText_image__Zivoo","load":"WidePictureNoText_load__gnNpy"};